module.exports = function(app) {
	require('./register/member-information')(app);
	require('./register/create-login')(app);
	require('./register/chip-14-confirmation')(app);
    require('./register/recovery-information')(app);

	app.controller('pages.register', ['$state', '$scope', '$location', '$anchorScroll', 'registration', 'registerNotifications', 'chevronContent', 'contentResourceServices',
        function($state, $scope, $location, $anchorScroll, registration, registerNotifications, chevronContent, contentResourceServices) {
            $scope.headings = 'REGISTER';
            $scope.showSidebar = false;
            $scope.chevron = { steps: [] };
            $scope.nextChevronSteps = [];
            $scope.memberIdMessage = "<p>Enter the Member ID or SSN for the main policyholder. This may not be you if your insurance is through another family member.</p>";
            var isVisitor = $state.params.userType == "medicareVisitor";
            var filterFn = registration.navigationFilter(isVisitor);
            contentResourceServices.updateResourcesAsync(chevronContent, filterFn, "Bluecore Navigation").then(function(items){
                var step1 = {};

                for (var k in items) {
                    if (items[k] && items[k].order === "1") {
                        step1 = items[k];
                    } else {
                        $scope.nextChevronSteps.push({ id: Number(items[k].order), label: items[k].label, state: items[k].state });
                    }
                }
                var initialSteps = [
                    { id: Number(step1.order), label: step1.label, state: step1.state },
                    { id: 999, label: "", state: "", hideIcon: true},
                    { id: 999, label: "", state: "", hideIcon: true}
                ];

                $scope.chevron = { steps: initialSteps };
                $scope.chevron.step = 1;
                $scope.chevron.parameters = {};
            });

            $scope.updateCurrentChevronStep = function(currentStep) {
                var updated = false;
                for (var i = 0; i < $scope.chevron.steps.length; i++) {
                    if ($state.current.name === $scope.chevron.steps[i].state) {
                        $scope.chevron.step = i+1;
                        updated = true;
                    }
                }
                if (!updated) {
                    $scope.chevron.step = 1;
                }
            };
            $scope.getPreviousStateFromChevron = function() {
                return $scope.chevron.steps[$scope.chevron.step-2].state;
            };
            $scope.getNextStateFromChevron = function() {
                return $scope.chevron.steps[$scope.chevron.step].state;
            };

            $scope.campaignID = $state.params.campaignId || '';
            $scope.validations = {};

            var filterFn = registration.notificationFilter('validation');
            contentResourceServices.updateResourcesAsync(registerNotifications, filterFn, "Bluecore Notification").then(function(items){
                for (var key in items) {
                    $scope.validations[items[key].id] = items[key].content;
                }
            });

            $scope.scrollTo = function(id){
                var old = $location.hash();
                $location.hash(id);
                $anchorScroll();
                //reset to old to keep any additional routing logic from kicking in
                $location.hash(old);
            };
        }
    ]);

    app.directive('registerValidationContainer', ['$timeout', function ($timeout) {
        return {
            restrict: "A",
            link: function (scope, element, attributes) {
                scope.$watch(function (){
                    return element.height();
                }, function(newVal, oldVal){
                    if (newVal > 33) {
                        $(element).css({"position":"relative", "margin-bottom":"-24px"});
                    } else {
                        $(element).css({"position":"", "margin-bottom":""});
                    }
                });
            }
        };
    }]);
};